(function(window, document, $) {
	'use strict';

	require('./misc/jquery-utils');
  require('./components/site/modal');
  require('./components/vimeo');
  require('./components/ie-warning');

  var util = require('./misc/util');
	var vestigo = require('./misc/vestigo');

	/**
	 * Main init function that kickstarts all site logic when the DOM is loaded
	 * Make sure all event handlers are placed within this function
	 *
	 * @private
	 */
	function _init() {
		// Parsley based form validation
		util.initFormValidation('.js-validate-form, .admin-container .main form');

		// Check for existing errors in tabs
		util.checkTabErrors('.admin-container .main form')

		// Custom event tracking
		// Tracks external links and downloads by default
		// Use vestigo.init().debug(); to see all logs
		vestigo.init();

		// General event delegation
		// Use this $(document) reference to chain other delegated events
		$(document)
			// Handle external links (the old way)
			.on('click', 'a[rel="external"]', util.setExtLinks)
			.on('click', '[data-action="print"]', function(e) {
				e.preventDefault();
				window.print();
			})
			.on('click', '[data-confirm]', function(e) {
				if (!confirm($(this).data('confirm'))) {
					e.preventDefault();
				}
			})
	}

	// Initialize
	$(document)
		.ready(_init)
		.ajaxError(util.processXhrError);
}(this, document, jQuery));
